import React from "react";
import { View } from "react-native";
import { BlurViewProps } from "./BlurView.native";

const BlurView = ({
    backgroundColor = "rgba(255, 255, 255, 0)",
    blurRadius = 3.5,
    borderRadius,
    ...props
}: BlurViewProps) => (
    <View
        style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: backgroundColor,
            overflow: "hidden",
            borderRadius,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            backdropFilter: `blur(${blurRadius}px)`,
        }}
        {...props}
    />
);

export default BlurView;
